import { render, staticRenderFns } from "./EditVote.vue?vue&type=template&id=7bd977a9&scoped=true&"
import script from "./EditVote.vue?vue&type=script&lang=js&"
export * from "./EditVote.vue?vue&type=script&lang=js&"
import style0 from "./EditVote.vue?vue&type=style&index=0&id=7bd977a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd977a9",
  null
  
)

export default component.exports